// extracted by mini-css-extract-plugin
export default {"hero":"Services_hero__gWr2Z","container":"Services_container__Dq1CS","badge":"Services_badge__RrXYY","title":"Services_title__qgmzz","subtitle":"Services_subtitle__pa-1r"};